<template>
    <div>
        <!-- Campo Pesquisa -->
        <v-row>
            <v-text-field v-model="search"
                color="primary"
                label="Pesquisa Espaço..."></v-text-field>
        </v-row>

        <v-row>
            <div class="text-caption text-disabled">
                {{StateEspacos.length}} Espaços
            </div>
            <v-spacer></v-spacer>
            <user-filiais-context class="mx-1"/>
            <v-chip color="primary" class="my-1"
                :disabled="StateEspacoLoading"
                @click="getEspacos">
                <span v-show="$vuetify.display.mdAndUp">Atualizar</span>
                <v-icon>mdi-refresh</v-icon>
            </v-chip>
        </v-row>
        <v-skeleton-loader v-if="StateEspacoLoading"
            type="list-item-two-line,list-item-two-line, list-item-two-line, list-item-two-line">
        </v-skeleton-loader>

        <v-card class="my-1" variant="outlined"
            v-for="item, espaco_index in computedEspacos"
            :key="espaco_index"
            v-show="!StateEspacoLoading">
            <v-card-text>
                <v-row>
                    <div class="text-subtitle-1 font-weight-medium my-1">
                        <v-icon class="mr-2" :color="item.color">mdi-circle</v-icon>{{item.descricao}}
                        <helper-gdb :text="item.instrucoes_espaco"
                            v-if="!!item.instrucoes_espaco"
                            icon-color="warning"/>
                    </div>
                </v-row>
                <v-row>
                    <v-chip v-for="f, fi in item.filiais_objects" label :key="fi" class="mr-1">
                        {{f.filial_codtipocurso_label}}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-chip label :color="item.ativo?'success':'error'" class="mx-1">
                        {{ item.ativo ? 'Ativo' : 'Inativo' }}
                    </v-chip>
                    <v-chip label color="grey" class="mx-1" @click="onCopyItem(item)"
                        title="Criar uma cópia do espaço">
                        <v-icon>mdi-content-copy</v-icon>
                    </v-chip>
                    <v-chip label color="info" class="mx-1" @click="onSelectItem(item)"
                        title="Alterar Espaço">
                        <v-icon>mdi-pencil</v-icon>
                    </v-chip>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'AgendaEspacoList',
    data: () => ({
        search:'',
        filter:{
            active:null,
            order:null
        }
    }),
    methods:{
        ...mapActions(['GetAgendaLabsEspacos','GetAgendaLabsTipoEspacos','GetFiliais','ListRoles']),
        async getEspacos(){
            let contexts = this.StateUserFiliais
            await this.GetAgendaLabsEspacos({contexts})
        },
        async getTipoEspaco(){
            await this.GetAgendaLabsTipoEspacos()
        },
        async init(){
            await this.getEspacos()
        },
        onSelectItem(item){
            this.$emit('on-select-item',item)
        },
        onCopyItem(espaco){
            const item = espaco
            delete item.id
            delete item.teams
            this.$emit('on-select-item',item)
        },
    },
    computed:{
        ...mapGetters(['StateEspacoLoading','StateEspacos', 'StateUserFiliais', 'StateDark']),
        computedEspacos(){
            let filtereds = this.StateEspacos.map(i => ({id: i.id, descricao: i.descricao, filiais_objects: i.filiais_objects}))
            if (this.search){
                filtereds = filtereds.filter(i => (i.descricao||'').toLowerCase().indexOf((this.search||'').toLowerCase()) !== -1)
            }
            const chaveUsuarioFiliais = this.StateUserFiliais.map(s=> `${s.codfilial}$_$${s.codtipocurso}`)
            filtereds = filtereds.filter(a => a.filiais_objects.filter(f => chaveUsuarioFiliais.includes(f.filial_chave) ).length > 0)
            let result = filtereds.map(i => this.StateEspacos.find(s => s.id === i.id))
            return  result
        }
    },
    mounted(){
        this.init()
    },
}
</script>